import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';

export default class CreatePasswordFormjs {

    constructor() {
        this.submitting = false;
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
    }

    init(container$) {

        var me = this;

        this.container$ = container$;
        this.form$ = container$;
        this.formMessage$ = container$.find(".FormMessage");

        this.form$.on("submit", function (e) {
            me.postCreatePasswordForm(e);
        });

        this.submitButton$ = this.form$.find("[type='submit']");
    }


    async postCreatePasswordForm(event) {
        event.preventDefault();

        if (this.submitting) return;
        this.submitting = true;

        const urlParams = window.location.search;
        const redirectUrl = $('#RedirectUrl').val();
        this.formMessage$.hide();
        this.formMessage$.removeClass();

        var me = this;

        return new Promise(
            function (res, rej) {
                var data = me.form$.serialize();
                $.post("/Signup/CreatePasswordForm" + urlParams, data)
                    .done(function (data) {
                        if (data.status === 200) {
                            me.formMessage$.show();
                            me.formMessage$.addClass('text-success');
                            me.formMessage$.text(data.response);

                            setTimeout(function () {
                                window.location.href = redirectUrl;
                            }, 1000);

                            res(data);
                        } else {
                            me.formMessage$.addClass('text-danger');
                            me.formMessage$.show();
                            me.formMessage$.text(data.response);
                            rej(data);
                        }
                        me.submitting = false;
                    });
            }
        );



    }

}


// WEBPACK FOOTER //
// ./Scripts/es6/controllers/createPasswordForm.js